export default __webpack_public_path__ + "static/media/2-4-2.73f5d528.jpg";